import {
  Dialog,
  BUTTON_VARIANTS,
  IconStatusWarningExclamation,
} from 'cdk-radial';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  min-width: 560px;
  max-width: 30%;
  margin-top: 60px;
  z-index: 9999;
`;

export const StyledDialogTitle = styled.div`
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 24px;
  color: #000000;
  text-transform: capitalize;
`;

export const StyledDialogTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledDialogContentText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

const StyledIconAccountCircle = styled(IconStatusWarningExclamation)`
  fill: #fa9c19;
  height: 38px;
  width: 38px;
  margin-right: 16px;
`;

interface IErrorHandlingDialog {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const SessionExpiryDialog = ({
  isOpen,
  onContinue
}: IErrorHandlingDialog): JSX.Element => {
  return (
    <div>
      <StyledDialog
        hideCloseButton
        disableOverlayClicked
        buttonsProps={[
          {
            id: 'error-dialog-reload-button',
            onClick: onContinue,
            text: "Sign Out",
            variant: BUTTON_VARIANTS.PRIMARY,
            style: {
              color: 'black',
              backgroundColor: '#E8E8E9',
            },
          },
        ]}
        id="error-handling-alert"
        isOpen={isOpen}
        title={
          <StyledDialogTitleContainer>
            <StyledIconAccountCircle />
            <StyledDialogTitle>
              Your session has expired
            </StyledDialogTitle>
          </StyledDialogTitleContainer>
        }
      >
      <StyledDialogContentText data-testid="errorDialogContent">
          For your security, you have been signed out due to inactivity. Sign in again to continue.
      </StyledDialogContentText>
      </StyledDialog>
    </div>
  );
};
export default SessionExpiryDialog;
